import ActivityReport from '../components/ActivityReport/ActivityReport';
import PageMain from '../components/Navigation/PageMain/PageMain';

export default function ActivityReportPage() {
    return (
        <PageMain pageTitle="Activity Report" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ActivityReport />
                </div>
            </div>
        </PageMain>
    );
}
